import React, { useEffect, useState } from 'react';
import {
  Button,
  Card, Col, Icon, Input, message, Row, Select, Table, Tag, Tooltip
} from 'antd';
import { useTranslation } from 'react-i18next';
import { Job } from '../../api/jobs/model';
import { ROWS_PER_PAGES } from '../../config/general-config';
import { createBaseGridParams, getUrlQueryString, GridParams } from '../../helpers/grid-helpers';
import { ContactDefaultRoute } from '../../api/contacts/enums';
import { CampaignEmailStatus, CampaignEmailStatusColorLabel } from '../../api/campaigns/enum';
import { useRouteMatch } from 'react-router-dom';
import JobsService from '../../api/jobs/JobsService';
import { JobEmailStatusCode, JobEmailStatusCodeLabel } from '../../api/jobs/enums';
import { PaginationConfig } from 'antd/lib/pagination';
import { SorterResult } from 'antd/lib/table';

const JobMessagesSocialMessages: React.FC<any> = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<{ id: string }>();
  const { id } = match?.params;
  const urlParams = getUrlQueryString();
  const gridParams = createBaseGridParams({
    sortOrder: 'descend',
    sortField: 'createdDate',
    // pageSize: ROWS_PER_PAGES,
  });
  const [gridState, setGridState] = useState<GridParams>({
    ...gridParams,
    filters: [],
    JobId: +id,
  });
  const [socialNetworkData, setSocialNetworkData] = useState<any>();
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState(urlParams.search || '');

  const handleOnSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
  };
  const handleSearch = (value: string) => {
    setGridState({ ...gridState, search: value, page: 0 });
  };

  const fetchSocialNetworkData = async () => {
    try {
      setIsLoading(true);
      const response = await JobsService.socialNetworkData(gridState);
      // const response = await SocialNetworkMessagesService.findGrid(gridState);
      setSocialNetworkData(response.list);
      setTotal(response.count);
    } catch (error) {
      if (error.message) message.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSocialNetworkData()
  }, [id, gridState]);

  const handleFilterChange = (filter: string, value: any) => {
    if (!value)
      setGridState({
        ...gridState,
        filters: [...gridState.filters!.filter((i) => i.key !== filter)],
      });
    else
      setGridState({
        ...gridState,
        filters: [...gridState.filters!.filter((i) => i.key !== filter), { key: filter, value }],
      });
  };

  const renderFilters = () => {
    return (
      <Row gutter={12}>
        <Col xs={24} sm={24} md={7} style={{ marginBottom: 10 }}>
          <Input.Search
            placeholder={`${t('Search')}...`}
            enterButton
            onChange={handleOnSearchChange}
            value={searchInput}
            onSearch={handleSearch}
          />
        </Col>

        <Col xs={24} sm={24} md={6}>
          <Select
            allowClear
            placeholder={t('Status')}
            style={{ width: '100%' }}
            onChange={(value: any) => handleFilterChange('status', value)}
          >
            {Object.keys(JobEmailStatusCode).map((status) => (
              <Select.Option key={status} value={status}>
                {t(JobEmailStatusCodeLabel[status as JobEmailStatusCode])}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
    );
  };

  const columns = [
    {
      title: t('Send Date'),
      dataIndex: 'createdDate',
      align: 'center' as 'center',
      render: (cell: any) => (cell ? cell?.toString()?.replace('T', " ")?.replace('Z', '')?.replaceAll('-', '/')?.split('.')[0] : '-'),
    },
    {
      title: t('Social Network'),
      dataIndex: 'socialMediaCode',
      align: 'center' as 'center',
      render: (cell: any) => (
        <Icon
          style={{ fontSize: 30 }}
          theme="filled"
          type={cell === ContactDefaultRoute.LINKEDIN ? 'linkedin' : 'facebook'}
        />
      ),
    },
    {
      title: t('Recipients'),
      dataIndex: 'recipients',
      align: 'center' as 'center',
      render: (cell: any) => (
        <a href={cell} target="_blank" rel="noopener noreferrer">
          {cell}
        </a>
      ),
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      align: 'center' as 'center',
      render: (status: string) => (
        <Tag color={CampaignEmailStatusColorLabel[status as CampaignEmailStatus]}>
          {t(status)}
        </Tag>
      ),
    },

  ];

  const handleTableOnChange = (
    pagination: PaginationConfig,
    filters: any,
    sorter: SorterResult<any>
  ) => {
    setGridState({
      ...gridState,
      sortField: sorter.columnKey || 'createdDate',
      sortOrder: sorter.order || 'descend',
      page: +pagination.current! - 1,
      pageSize: +pagination.pageSize!,
    });
  };


  return (
    <Card className="job-offer__description">
      <Table
        style={{ marginTop: '15px' }}
        rowKey="id"
        bordered
        showHeader
        loading={isLoading}
        title={renderFilters}
        onChange={handleTableOnChange}
        pagination={{
          showTotal: (totalRecords, rangeRecords) =>
            `${rangeRecords[0]}-${rangeRecords[1]} ${t('of')} ${totalRecords} ${t('items')}`,
          current: gridState.page! + 1,
          pageSize: gridState.pageSize,
          total,
        }}
        columns={columns}
        dataSource={socialNetworkData}
      />
    </Card>
  );
};

export default JobMessagesSocialMessages;
